export function SectionTitle({ children, subtitle }) {
    return (
        <div className="text-center mb-10">
            <span className="text-sp-primary font-bold text-sm uppercase tracking-wider">
                {subtitle}
            </span>
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-black text-sp-text mt-1">
                {children}
            </h2>
        </div>
    );
}